const KEY = 'cv-portal:profile-completion-panel-open';

export const getProfileCompletionPanelOpen = (): boolean => {
    const stored = localStorage.getItem(KEY);
    return stored === null ? true : stored === 'true';
};

export const setProfileCompletionPanelOpen = (open: boolean): void =>
    localStorage.setItem(KEY, String(open));
